<template>
  <div class="BoyoTable">
    <div ref="tableMode_one"
         class="tableMode_one">
      <el-table :data="tableInfo.data"
                ref="table"
                highlight-current-row
                :resizable="tableInfo.resizable?tableInfo.resizable:true"
                :border="tableInfo.resizable?tableInfo.resizable:true"
                :max-height="tableInfo.height?tableInfo.height:maxHeight"
                :summary-method="getSummaries"
                :span-method="tableInfo.spanMethod"
                :show-summary="tableInfo.showSummary !== false"
                :row-key="tableInfo.key"
                :default-expand-all="tableInfo.expand"
                :tree-props="tableInfo.props"
                tooltip-effect="dark"
                :row-style="tableRowClassName"
                :header-cell-style="{background:'#eff3f8',color:'black','border-bottom':'1px solid #cccccc','border-left':tableInfo.borderLeft?'1px solid #cccccc':'','font-size':'14px',padding:'2px 0'}"
                :cell-style="tableCellClassName"
                @row-dblclick="rowDblclick"
                @selection-change="handleSelectionChange"
                @select-all="selectChange"
                @row-click="rowClick">
            <el-table-column v-if="tableInfo.selection"
                         type="selection" width="60"
                         fixed>
        </el-table-column>
            <!-- <el-table-column v-if="tableInfo.selection"
                          width="60"
                          fixed>
            <template slot="header">
              <input type="checkbox"
                    v-model="checkAll"
                    @change="checkAllClick">
            </template>
            <template slot-scope="scope">
              <input type="checkbox"
                    v-model="ckeckVal[scope.$index]"
                    @change="checkboxOnclick(scope.$index,scope.row)">
            </template>
          </el-table-column> -->
          <el-table-column v-if="tableInfo.selectionTwo"
                          type="selection"
                          :selectable="selected"
                          width="55"
                          fixed="left">
          </el-table-column>
          <el-table-column type="index"
                          label="序"
                          v-if="tableInfo.xuhao"
                          width="50"
                          fixed="left">
          </el-table-column>
          <template v-for="item of tableInfo.fieldList">
            <el-table-column v-if="item.childBase"
                           :key="item.value"
                           :label="item.label"
                           :align="item.align||'center'"
                           :sortable="item.sortable ">
                <template v-for="item2 of item.childBase">
                  <el-table-column :key="item2.value"
                                :label="item2.label"
                                :prop="item2.value"
                                :show-overflow-tooltip="item2.type!=='button'?true:false"
                                :width="item2.width"
                                :min-width="item2.minWidth"
                                :align="item2.align||'center'"
                                :fixed="item2.fixed"
                                :sortable="item2.sortable">
                    <template slot-scope="scope">
                      <!-- 表格列自定义插槽 -->
                      <template v-if="item.label == '车牌号' && (scope.row.routerName == '调拨预约' || scope.row.routerName == '销售预约' || scope.row.routerName == '采购预约' || scope.row.routerName == '预约审批' || scope.row.routerName == '安排抽检')">
                        <span style="color:red">{{ scope.row[item2.value]}}</span>
                      </template>
                      <template v-else>
                        {{ scope.row[item2.value]}}
                      </template>
                    </template>
                  </el-table-column>
                </template>
              </el-table-column>
              <el-table-column v-else-if="item.show"
                            :key="item.value"
                            :label="((item.label.indexOf('金额') != -1 && item.label.indexOf('元') == -1) || (item.label.indexOf('单价') != -1 && item.label.indexOf('株') != -1) || item.label.indexOf('余额') != -1 || item.label.indexOf('额度') != -1 || item.label.indexOf('税金') != -1 || item.label.indexOf('税额') != -1 || (item.label.indexOf('运费') != -1 && item.label.indexOf('运费合同') == -1 && item.label.indexOf('运费单号') == -1) || item.label.indexOf('总应收款') != -1 || item.label.indexOf('税费合计') != -1 || item.label === '预收款') ? (item.label + '('+ amountUnit +')') : item.label"
                            :prop="item.value"
                            :show-overflow-tooltip="item.type!=='button'?true:false"
                            :width="item.width"
                            :min-width="item.minWidth"
                            :align="item.align||'center'"
                            :fixed="item.fixed"
                            :sortable="item.sortable ">
              <template slot-scope="scope">
                <!-- 表格列自定义插槽 -->
                <template v-if="item.type === 'slot'">
                  <slot :name="'col-' + item.value"
                        :row="scope.row"
                        :index="scope.$index" />
                </template>
                <template v-else-if="item.type === 'switch'">
                  <el-switch v-for="item of tableInfo.btList1"
                            v-model="scope.row.switch"
                            :key="item.event"
                            @change="changeSwitch(scope.$index, scope.row,item.event)">
                    <!-- <i :class="item.icon">{{item.label}}</i> -->
                  </el-switch>
                </template>
                <template v-else-if="item.type === 'button'">
                  <el-button v-for="e of tableInfo.btList"
                            :key="e.event"
                            :style="e.style"
                            size="mini"
                            @click="TableEvent(scope.$index, scope.row,e.event)">
                    <i :class="e.icon">{{e.label}}</i>
                  </el-button>
                </template>
                <template v-else-if="item.list">
                  {{getlistTypeInfo(scope.row[item.value],item.list)}}
                </template>
                <template v-else-if="item.label == '车牌号' && (scope.row.routerName == '调拨预约' || scope.row.routerName == '销售预约' || scope.row.routerName == '采购预约' || scope.row.routerName == '预约审批' || scope.row.routerName == '安排抽检')">
                  <span style="color:red">{{ scope.row[item.value]}}</span>
                </template>
                <template v-else-if="(item.label.indexOf('数量') != -1 && item.label.indexOf('卸车数量') == -1 && item.label.indexOf('当前库存数量') == -1) || item.label.indexOf('计划产量') != -1 || item.label == '合同数' || item.label == '已到货未到票' || item.label == '已到货未付款' || item.label.indexOf('送货量') != -1 || item.label.indexOf('金额') != -1 || item.label.indexOf('单价') != -1 || item.label.indexOf('余额') != -1 || item.label.indexOf('额度') != -1 || item.label.indexOf('税金') != -1 || item.label.indexOf('税额') != -1 || (item.label.indexOf('运费') != -1 && item.label.indexOf('运费合同') == -1 && item.label.indexOf('运费单号') == -1) || item.label.indexOf('总应收款') != -1 || item.label.indexOf('税费合计') != -1 || item.label === '预收款'">
                  <span style="width: 100%;text-align: right;">{{ formatAmount(scope.row[item.value])}}</span>
                </template>
                <template v-else>
                  {{ scope.row[item.value]}}
                </template>
              </template>
            </el-table-column>
          </template>
      </el-table>
    </div>
    <table border="1"
           ref="tableMode_two"
           class="tableMode_two">
      <tr v-for="(data,index) of tableInfo.data"
          :key="data.value">
        <td class="td">
          <div style="width:100%"
               v-if="tableInfo.selection">
            <input type="checkbox"
                   v-model="ckeckVal[index]"
                   @change="checkboxOnclick(index,data)">
          </div>
          <div v-for="item of tableInfo.fieldList"
               :key="item.value">
            <div v-if="item.show==='true'">
              <span class="title">{{item.label}}</span>
              <!-- <span v-if="item.type==='switch'">
                <el-switch v-model="value"
                           active-color="#13ce66"
                           inactive-color="#ff4949"
                           @click="changeSwitch (index, data, event)">
                </el-switch>
              </span> -->
              <span v-if="item.type==='button'">
                <el-button v-for="item of tableInfo.btList"
                           :key="item.event"
                           :style="item.style"
                           size="mini"
                           @click="TableEvent(index, data,item.event)">
                  <i :class="item.icon">{{item.label}}</i>
                </el-button>
              </span>
              <span v-else-if="item.type==='slot'">
                <slot :name="'col-' + item.value"
                      :row="data"
                      :index="index" />
              </span>
              <span v-else-if="item.list">
                {{getlistTypeInfo(data[item.value],item.list)}}
              </span>
              <el-tooltip v-else-if="item.type==='over'"
                          effect="dark"
                          :content="''+data[item.value]"
                          placement="top">
                <el-button style="background:none;padding:0;color:#676a6c;font-size:13px;cursor:auto">
                  <span class="item">{{data[item.value]}}</span>
                </el-button>
              </el-tooltip>
              <span class="item"
                    :title="data[item.value]"
                    v-else>{{data[item.value]}}</span>
            </div>
          </div>
        </td>
      </tr>
    </table>
    <div v-if="tableInfo.pager && (tableInfo.showVisitorOrderSum || tableInfo.showVisitorTicketSum)"
         class="table-pager-footer">
      <div class="table-pager-footer__sum">
        <span v-if="tableInfo.showVisitorOrderSum">
          合计购买数量{{formatSumNum(tableInfo.sumData.buyNum, 0)}},合计订单总金额{{formatSumNum(tableInfo.sumData.totalAmount, 2)}},合计实际支付金额{{formatSumNum(tableInfo.sumData.payAmount, 2)}}。
        </span>
        <span v-else-if="tableInfo.showVisitorTicketSum">
          合计购票金额{{formatSumNum(tableInfo.sumData.buyAmount, 2)}}。
        </span>
      </div>
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     background
                     :small="true"
                     :current-page="filterInfo.pageNumber"
                     :page-sizes="[10, 20, 30, 50, 80, 100, 200]"
                     :page-size="filterInfo.pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="tableInfo.total">
      </el-pagination>
    </div>
    <el-pagination v-else-if="tableInfo.pager"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   background
                   :small="true"
                   style="margin-top:10px"
                   :current-page="filterInfo.pageNumber"
                   :page-sizes="[10, 20, 30, 50, 80, 100, 200]"
                   :page-size="filterInfo.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="tableInfo.total">
    </el-pagination>
    <div v-if="!tableInfo.pager && !tableInfo.showSum1"
         v-show="!tableInfo.accessShow"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      共{{tableInfo.total}}条记录。
    </div>
    <div v-if="tableInfo.pager2"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      合计共{{tableInfo.total}}车，合计毛重{{tableInfo.sumgrossWeight}}
    </div>
    <div v-if="tableInfo.showNum2"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      合计共{{tableInfo.total}}条记录,计划车数{{tableInfo.sumData.carNumber}},计划数量{{tableInfo.sumData.baseQuantity}},车数{{tableInfo.sumData.actualCarNumber}},净重{{tableInfo.sumData.netQuantity}},车数(退){{tableInfo.sumData.returnCarNumber}},净重(退){{tableInfo.sumData.returnNetQuantity}},运输数量{{tableInfo.sumData.transportQuantity}},运输数量(退){{tableInfo.sumData.returnTransportQuantity}}。
    </div>
    <div v-if="tableInfo.showNum"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      共{{tableInfo.total}}条记录,合计净重量{{tableInfo.sumData.sumnetWeigh}},合计扣杂{{tableInfo.sumData.sumImpurities}},合计实重{{tableInfo.sumData.sumweight}},合计整单扣额{{tableInfo.sumData.sumpriceAdjust}},合计金额{{tableInfo.sumData.sumpayAdjust}}。
    </div>
    <div v-if="tableInfo.showSum"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      共{{tableInfo.total}}条记录
      ,合计净重量{{tableInfo.sumData.sumnetWeigh}},合计扣杂{{tableInfo.sumData.sumImpurities}},合计实重{{tableInfo.sumData.sumweight}}。
    </div>
    <div v-if="tableInfo.showSum2"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      <!-- 共{{tableInfo.total}}条记录, -->
      本页小计：合计毛重{{tableInfo.sumData.sumarriveWeigh}},合计皮重{{tableInfo.sumData.sumleaveWeigh}},合计净重量{{tableInfo.sumData.sumnetWeigh}},合计扣杂{{tableInfo.sumData.sumImpurities}},合计实重{{tableInfo.sumData.sumweight}}。
    </div>
    <div v-if="tableInfo.ShipList"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      本页合计：合计毛重{{tableInfo.sumData.sumgrossWeight}},合计皮重{{tableInfo.sumData.sumtareWeight}},合计净重量{{tableInfo.sumData.sumnetWeigh}},合计扣杂{{tableInfo.sumData.sumImpurities}},合计实重{{tableInfo.sumData.sumtrueWeigh}}。
    </div>
    <div v-if="tableInfo.showSum3"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      共{{tableInfo.total}}条记录
      ,合计毛重{{tableInfo.arriveWeight}},合计皮重{{tableInfo.leaveWeight}},合计净重量{{tableInfo.netWeigh}},合计扣杂{{tableInfo.Impurities}},合计实重{{tableInfo.actualWeight}}。
      <!-- ,合计车数{{tableInfo.sumData.sumcountShipCar}}。 -->
    </div>
    <div v-if="tableInfo.showSum4"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      共{{tableInfo.total}}条记录
      ,合计毛重{{tableInfo.grossWeight}},合计皮重{{tableInfo.tareWeight}},合计净重量{{tableInfo.netWeigh}},合计扣杂{{tableInfo.Impurities}},合计实重{{tableInfo.actualWeight}}。
    </div>
    <div v-if="tableInfo.showSum1"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      共{{tableInfo.total}}条记录,合计毛重{{tableInfo.sumData1.sumGrossWeight}},合计皮重{{tableInfo.sumData1.sumTareWeight}},合计净重{{tableInfo.sumData1.sumnetWeigh}}。
    </div>
    <div v-if="tableInfo.showVisitorOrderSum && !tableInfo.pager"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      合计购买数量{{formatSumNum(tableInfo.sumData.buyNum, 0)}},合计订单总金额{{formatSumNum(tableInfo.sumData.totalAmount, 2)}},合计实际支付金额{{formatSumNum(tableInfo.sumData.payAmount, 2)}}。
    </div>
    <div v-if="tableInfo.showVisitorTicketSum && !tableInfo.pager"
         style="margin-top:10px;color:#606266;font-size:13px;text-align:left">
      合计购票金额{{formatSumNum(tableInfo.sumData.buyAmount, 2)}}。
    </div>
  </div>
</template>
<script>
export default {
  name: 'BoyoTabletwo',
  props: {
    tableInfo: Object,
    filterInfo: Object,
    listTypeInfo: Object
  },
  data () {
    return {
      // mark: true,
      total: 0,
      checkboxList: [],
      ckeckVal: [],
      checkAll: false,
      maxHeight:null,
      amountUnit:localStorage.amountUnit?localStorage.amountUnit:'元',
    }
  },
  watch: {
    'tableInfo.mode' (val) {
      let screenWidth = document.body.clientWidth
      if (screenWidth <= 960) {
        this.$refs.tableMode_one.style.cssText = this.$refs.tableMode_one.style.display === 'block' ? 'display:none' : 'display: block'
        this.$refs.tableMode_two.style.cssText = this.$refs.tableMode_two.style.display === 'none' ? 'display: table' : 'display: none'
      } else {
        this.$refs.tableMode_one.style.cssText = this.$refs.tableMode_one.style.display === 'none' ? 'display:block' : 'display: none'
        this.$refs.tableMode_two.style.cssText = this.$refs.tableMode_two.style.display === 'table' ? 'display: none' : 'display: table'
      }
      this.$refs.tableMode_two.style.width = '100%'
    },
    'tableInfo.selectReset' (val) {
      this.checkboxList = []
      this.ckeckVal = []
      this.checkAll = false
      this.$emit('handleSelectionChange', this.checkboxList)
    },
    'tableInfo.selectcancel' (val) {
      // this.checkboxList = []
      this.checkboxList = this.checkboxList.splice(val.length-1,1)
      this.ckeckVal = []
      this.checkAll = false
      this.$emit('handleSelectionChange', this.checkboxList)
    }
  },
  mounted () {
    // console.log(this.ckeckVal);
    this.$emit('update:refObj', this.$refs.table)
    this.updateMaxHeight()
  },
  methods: {
    updateMaxHeight () {
      if (!document.body.clientHeight || !this.$refs.table) {
        this.maxHeight = '500px'
        return
      }
      const bottomReserve = this.tableInfo.totalHeightBot ? Number(this.tableInfo.totalHeightBot) : 0
      this.maxHeight = document.body.clientHeight - bottomReserve - this.$refs.table.$el.offsetTop - 201 + 'px'
    },
    formatAmount(cellValue) {
      // console.log(row, column, cellValue, index)
      if (typeof cellValue == 'number') {
        cellValue = Number(cellValue.toFixed(3))
        return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    formatSumNum (val, fixed) {
      if (val == null || val === '') return '0'
      const num = Number(val)
      if (isNaN(num)) return val
      const str = fixed != null ? num.toFixed(fixed) : String(num)
      return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getSummaries (param) {
      //param 是固定的对象，里面包含 columns与 data参数的对象 {columns: Array[4], data: Array[5]},包含了表格的所有的列与数据信息
      const { columns, data } = param;
      //console.log(data)
      const sums = [];
      const summaryColIndex = (this.tableInfo.selection || this.tableInfo.selectionTwo ? 1 : 0)
        + (this.tableInfo.xuhao ? 1 : 0)
      columns.forEach((column, index) => {
        //console.log(column)
        //console.log(index)
        if (index < summaryColIndex) {
          sums[index] = '';
          return;
        }
        if (index === summaryColIndex) {
          sums[index] = this.tableInfo.summaryLabel || '小计';
          return;
        }
        const summaryData = data.filter(item => String(item.id) !== 'sum-row')
        const values = summaryData.map(item => Number(item[column.property]));
        //验证每个value值是否是数字，如果是执行if
        // if (!values.every(value => isNaN(value))) {
        if (column.property === 'shouldPay'|| column.property === 'baseSalary' || column.property === 'leaveWeighAmount' || column.property === 'tareQuantity' || column.property === 'grossQuantity' || column.property === 'deductDregQuantity' || column.property === 'deductWaterQuantity'  || column.property === 'packingQuantity'
          || column.property === 'arriveWeighAmount' || column.property === 'realQuantity' || column.property === 'allGoodsQty' || column.property === 'carTareQuantity' || column.property === 'carGrossQuantity' || column.property === 'carRealQuantity' || column.property === 'actualWeight'
          || column.property === 'returnTareQuantity' || column.property === 'returnGrossQuantity' || column.property === 'returnRealQuantity'
          || column.property === 'totalProfit' || column.property === 'actualPayment' || column.property === 'totalCost' || column.property === 'totalAmount' || column.property === 'totalTaxAmount' 
          || column.property === 'salesCost' || column.property === 'salesAmount' || column.property === 'leaseCost' || column.property === 'leaseAmount' || column.property === 'baseMoney' || column.property === 'baseQuantity' || column.property === 'taxMoney' || column.property === 'totalQuantity' ||column.property === 'totalMoney' || column.property === 'totalTaxMoney'
          || column.property === 'quantity' || column.property === 'amount'|| column.property === 'income'|| column.property === 'pay' || column.property === 'refundAmount'
          || column.property === 'balancePayable'|| column.property === 'amountPaid'|| column.property === 'actualMoney'|| column.property === 'todayOutAmount'|| column.property === 'todayOutTaxAmount'|| column.property === 'taxAmount'|| column.property === 'presentNetWeigh' || column.property === 'notTaxAmount' || column.property === 'withholdVat'
          || column.property === 'purchaseMoney'|| column.property === 'type1'|| column.property === 'type2'|| column.property === 'type3'|| column.property === 'count' || column.property === 'unAmountCollected'|| column.property === 'carGrossWeight'|| column.property === 'carTareWeight'|| column.property === 'errorWeigh'
          || column.property === 'totalNums'|| column.property === 'transportQuantity'|| column.property === 'returnTransportQuantity'|| column.property === 'returnNetQuantity'|| column.property === 'netQuantity'|| column.property === 'carNumber'|| column.property === 'actualCarNumber'|| column.property === 'returnCarNumber' || column.property === 'invoiceMoney'
          || column.property === 'carTransportQuantity' || column.property === 'weight' || column.property === 'payMoney' || column.property === 'netWeigh' || column.property === 'newImpurities' || column.property === 'weigh' || column.property === 'contractAmount' || column.property === 'totalBaseQuantity' || column.property === 'invoiceQuantity'
          || column.property === 'settleAmount'|| column.property === 'settleTaxAmount'|| column.property === 'settleExctTaxAmount'|| column.property === 'settleQuantity' || column.property === 'zeroMoney' || column.property === 'paymentMoney' || column.property === 'salExctTaxMoney' || column.property === 'salMoney' || column.property === 'salQuantity' || column.property === 'actualExctTaxMoney'
          || column.property === 'receiveMoney'|| column.property === 'receivableTaxAmount'|| column.property === 'receivableAmount' || column.property === 'carrierTransportAmount' || column.property === 'advanceAmount' || column.property === 'salQuantityDelivery' || column.property === 'outboundQuantity' || column.property === 'outboundMoney'
           || column.property === 'purExctTaxMoney'|| column.property === 'purTaxMoney'|| column.property === 'purMoney' || column.property === 'totalPurQuantity' || column.property === 'totalPurAmount' || column.property === 'totalExctTaxAmount' || column.property === 'sumTotalBaseQuantity' || column.property === 'sumTotalPurAmount' || column.property === 'unBaseQuantity' || column.property === 'amountCollected'
           || column.property === 'invoicePrice'|| column.property === 'unPurMoney'|| column.property === 'unInvoicePrice' || column.property === 'shipNetWeight' || column.property === 'totalInvoicePrice' || column.property === 'totalNotInvoicePrice' || column.property === 'totalSalQuantity' || column.property === 'totalSalAmount' || column.property === 'unInvoiceMoney'
           || column.property === 'todayWeightCar'|| column.property === 'unloadingYesterdayCar'|| column.property === 'dayUnloadingTrucks'|| column.property === 'nightUnloadingTrucks'|| column.property === 'documentTrainNumber'|| column.property === 'dayNotUninstalled'|| column.property === 'sumDeductionWeight'|| column.property === 'carQuantity' || column.property === 'todayInAmount'
           || column.property === 'unloadingRateTwo'|| column.property === 'proportionTwo'|| column.property === 'vehiclesQuantity' || column.property === 'arrivalQuantity'|| column.property === 'deductSoil' || column.property === 'deductIron'  || column.property === 'deductWater' || column.property === 'impurities'|| column.property === 'finalNetWeight' || column.property === 'todayInTaxAmount'
           || column.property === 'shippedQuantity'|| column.property === 'actualQuantity'|| column.property === 'unshippedQuantity' || column.property === 'unQuantity'|| column.property === 'carNetWeight' || column.property === 'deductSeal'  || column.property === 'addDeductWater'|| column.property === 'shipDeductWeight' ||  column.property === 'carDeductWeight'
           || column.property === 'grossWeight'|| column.property === 'tareWeight'|| column.property === 'netWeight' ||  column.property === 'withholdingVat' ||  column.property === 'withholdingVatSurcharge' ||  column.property === 'withholdingPersonalIncome' ||  column.property === 'actualPaymentAmount' || column.property === 'todayOutQuantity' || column.property === 'todayInQuantity'
           || column.property === 'containerQuantity'|| column.property === 'containerAmount'|| column.property === 'containerPlanQuantity' ||  column.property === 'containerPlanAmount' ||  column.property === 'entryAmount' || column.property === 'carNum' || column.property === 'containerSettleQuantity' || column.property === 'containerSettleAmount' || column.property === 'containerActualPaymentAmount'
           || column.property === 'actualAmount'|| column.property === 'settledAmount'|| column.property === 'unsettledAmount'|| column.property === 'arriveQuantity' || column.property === 'wastageQuantity'|| column.property === 'wastageAmount' || column.property === 'monthInventory' || column.property === 'inTransit' || column.property === 'incomingVolume' || column.property === 'recycle' || column.property === 'usage'
           || column.property === 'inventoryQuantity' || column.property === 'inventoryAmount'
           || column.property === 'purNetQuantity' || column.property === 'purDeductQuantity' || column.property === 'purSettleQuantity' 
           || column.property === 'purExctTaxAmount' || column.property === 'purAmount' || column.property === 'purWithholdingVat' || column.property === 'purWithholdingVatSurcharge' 
           || column.property === 'purWithholdingPersonalIncome' || column.property === 'purTotalWithholding' || column.property === 'purAmountTwo' 
           || column.property === 'purSettleAmount' || column.property === 'evaluationAmount' || column.property === 'exctTaxAmount' || column.property === 'totalWeigh' || column.property === 'totalImpurities' || column.property === 'totalAmountPayable'
           || column.property === 'totalNotTaxAmount' || column.property === 'totalwithholdVat' || column.property === 'totalContractAmount' || column.property === 'totalNotContractAmount' || column.property === 'totalPayMoney'
          || column.property === 'orderCount' || column.property === 'onlineAmount' || column.property === 'storeAmount'
          || column.property === 'verifyCount' || column.property === 'verifyAmount'
          || column.property === 'buyNum' || column.property === 'payAmount'
          || column.property === 'sellCount' || column.property === 'totalPayAmount'
          || column.property === 'buyAmount'
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              // let prev1 = Number(prev).toFixed(3)
              // let curr1 = Number(curr).toFixed(3)
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (column.label=="截止19:00卸铁率%" && column.property === 'unloadingRateTwo' && sums[5] && sums[2]) {
            sums[index] = Number(((1 - Number(sums[5].replace(/,/g,''))/Number(sums[2].replace(/,/g,'')))*100).toFixed(2))
          }else if (column.label=="扣杂大于300KG占全部车辆总占比%" && column.property === 'unloadingRateTwo' && sums[9] && sums[2]) {
            sums[index] = Number(((Number(sums[9].replace(/,/g,''))/Number(sums[2].replace(/,/g,'')))*100).toFixed(2))
          }else if (column.label=="扣杂占比%" && column.property === 'proportionTwo' && sums[2] && sums[3]) {
            sums[index] = Number(((Number(sums[3].replace(/,/g,''))/Number(sums[2].replace(/,/g,'')))*100).toFixed(2))
          } else {
            sums[index] = this.formatAmount(Number(Number(sums[index]).toFixed(3)))
          }
        }
      });
      this.$emit('getSummaries', sums)
      return sums;
    },
    getlistTypeInfo (val, list) {
      for (let i in this.listTypeInfo[list]) {
        if (val === this.listTypeInfo[list][i].value) {
          return this.listTypeInfo[list][i].label
        }
      }
    },
    // 原生checkbox事件
    checkboxOnclick (index, data) {
      let ckeckVal = this.ckeckVal
      const arr = JSON.parse(JSON.stringify(this.checkboxList))
      if (ckeckVal[index]) {
        this.checkboxList.push(data)
      } else {
        for (let i in this.checkboxList) {
          if (this.checkboxList[i].id === data.id) {
            arr.splice(i, 1)
            break
          }
        }
        this.checkboxList = arr
      }
      if (this.checkboxList.length === this.tableInfo.data.length) {
        this.checkAll = true
      } else if (this.checkboxList.length === 0) {
        this.checkAll = false
      }
      this.$emit('handleSelectionChange', this.checkboxList)
    },
    // 全选
    checkAllClick () {
      let checkAll = this.checkAll
      let ckeckVal = this.ckeckVal
      let data = this.tableInfo.data
      if (checkAll) {
        for (let i in data) {
          ckeckVal[i] = true
        }
        this.checkboxList = data
      } else {
        for (let i in data) {
          ckeckVal[i] = false
        }
        this.checkboxList = []
      }
      this.$emit('handleSelectionChange', this.checkboxList)
    },
    // 表格单选框事件
    handleSelectionChange (val) {
      this.$emit('handleSelectionChange', val)
    },
    selectChange (val) {
      this.$emit('selectChange', val)
    },
    tableRowClassName({row, rowIndex}){//背景色
        // console.log({row, rowIndex})
      if ((row.routerName == '船运列表' && row.returnFlag && row.returnFlag == 1) || (row.isRange == 1 && row.routerName == '称重记录')) {
        return {
          color: 'red'
        }
      }
    },
    tableCellClassName({row, column, rowIndex, columnIndex}){//背景色
      if (column.label == '车牌号' && row.routerName && (row.routerName == '预约打印' || row.routerName == '车辆入厂' || row.routerName == '采样确认' || scope.row.routerName == '检测结果')) {
        return {
          padding: '4px',
          'border-left': '1px solid #ccc',
          color: 'red'
        }
      } else if ((row.salReviewFlag && row.salReviewFlag == 2 && column.label == '销售分管') || (row.purReviewFlag && row.purReviewFlag == 2 && column.label == '采购分管') || (row.curStateName && row.curStateName.indexOf('不通过') != -1 && column.label == '当前状态')) {
        return {
          padding: '4px',
          'border-left': '1px solid #ccc',
          color: 'red'
        }
      } else{
        return {
            padding: '4px',
            'border-left': '1px solid #ccc',
          }
      }
    },
    // 表格行单击事件
    rowClick (row) {
      this.$emit('TableEvent', 'null', row, 'rowClick')
    },
    // 表格行双击事件
    rowDblclick (row, column, event) {
      this.$emit('TableEvent', row, column, 'rowDblclick')
    },
    // 表格内部按钮事件
    changeSwitch (index, row, event) {
      this.$emit('changeSwitch', index, row, event)
    },
    TableEvent (index, row, event) {
      this.$emit('TableEvent', index, row, event)
    },
    handleSizeChange (pageSize) {
      this.$emit('handleSizeChange', pageSize)
    },
    handleCurrentChange (pageNumber) {
      this.$emit('handleCurrentChange', pageNumber)
    },
    selected(row, index) {
      // console.log(row, index)
      if (Number(row.selectFlag) == 1) {
        return false //不可勾选
      } else {
        return true //可勾选
      }
    },
  }
}
</script>
<style lang="stylus" scoped>
.table-pager-footer
  display flex
  flex-direction column
  align-items center
  margin-top 10px
  gap 8px

.table-pager-footer__sum
  width 100%
  color #606266
  font-size 13px
  text-align left
  line-height 1.4
</style>



// WEBPACK FOOTER //
// src/components/BoyoTabletwo/index.vue